import {api} from "@/utils/client";

const state = {
    jobs: {
        meta: {total: 0, last_page:1, current_page:1}, 
        data:[]
    },
    jobDetail: null,

    jobStatuses: {
        hold: 'On Hold',
        draft: 'Pre-Production',
        production_ready: 'Starting Production',
        ordered: 'In Production',
        qc: 'Quality Control',
        production_done: 'Production Done',
        packaging: 'Packaging',
        sent: 'Shipping',
        completed: 'Complete'
    },
    enquiryStatuses: {
        enquiry_fresh: 'Fresh Enquiry',
        enquiry_progress: 'In Progress',
        enquiry_invoice: 'Waiting For Invoice',
        enquiry_payment: 'Waiting For Payment',
        enquiry_ready: 'Ready For Production',
        enquiry_ignored: 'Ignored Enquiry',
        enquiry_cancelled: 'Cancelled Enquiry',
    },
    enquirySources: {
        builder: 'Web Builder',
        form: 'Web Form',
        product: 'Web Product',
        email: 'Email Enquiry',
        phone: 'Phone Enquiry',
        'new-order': 'BB HUB New Order',
        're-order': 'BB HUB Re - Order',
        manual: 'Manual Entry',
        unknown: 'Unknown',
    },
}

// actions
const actions = {
    async fetchOMSJobs(context, params = {}) {
        try {
            params.team_id = context.rootState.teamId;
            let response = await api.get('/oms-ws/jobs', {params:params});
            context.commit('fetchOMSJobs', response.data);
            return response;
        } catch (e) { console.log(e); throw e; }
    },
    async getOMSJob(context, params = {}) {
        try {
            params.team_id = context.rootState.teamId;
            let response = await api.get('/oms-ws/jobs/' + params.job_id, {params:params});
            context.commit('getOMSJob', response.data);
            return response;
        } catch (e) { console.log(e); throw e; }
    },
    async getOMSAttachment(context, params = {}) {
        try {
            params.team_id = context.rootState.teamId;
            return await api.get('/oms-ws/attachment/' + params.attachment_id, {params: params});
        } catch (e) { console.log(e); throw e; }
    },
    async sendOMSEnquiry(context, params = {}) {
        try {
            params.team_id = context.rootState.teamId;
            return await api.post('/oms-ws/enquiry', params);
        } catch (e) { console.log(e); throw e; }
    },
    
}
// mutations
const mutations = {
    fetchOMSJobs(state, data) {
        //if (data.data) data.data.forEach((item) => { item.selected = false });
        state.jobs = data.response;
    },
    getOMSJob(state, data) {
        //if (data.data) data.data.forEach((item) => { item.selected = false });
        state.jobDetail = data.response.data;
    },
}

export default {
    state,
    actions,
    mutations
}
